export type Environment = "prod" | "staging";

/** Kept free of `import.meta.env` so the browser tests can import it in Node. */
export const resolveEnvironment = (mode: string): Environment => (mode === "production" ? "prod" : "staging");
